@if (!dataIn.mobile) {
  <rk-modal-wrapper
    (submitted)="onSubmit()"
    (cancelled)="onCancel()"
    (closed)="onCancel()"
    [title]="'MEDIA.MODAL.PLAYLIST.DELETE.TITLE' | translate"
    [submitText]="'MEDIA.MODAL.TRACK.DELETE.ACTION_BUTTON' | translate"
    [loading]="isLoading$ | async"
    [hideCancelOnLoading]="true"
  >
    <div
      class="head-delete-playlist-modal-component"
      [innerHTML]="
        'MEDIA.MODAL.PLAYLIST.DELETE.HEADER' | translate: { name: dataIn.playlist.name }
      "
    ></div>
  </rk-modal-wrapper>
} @else {
  <rk-mobile-close-button
    class="fixed z-10"
    (click)="onCancel()"
  ></rk-mobile-close-button>
  <div class="p-5">
    <div
      class="modal-content font-bold md:font-normal text-black text-2xl md:text-1.5xl"
      [innerHTML]="
        'MEDIA.MODAL.PLAYLIST.DELETE.HEADER' | translate: { name: dataIn.playlist.name }
      "
    ></div>
    <rk-footer-actions
      [submitText]="'MEDIA.MODAL.TRACK.DELETE.ACTION_BUTTON' | translate"
      [inline]="true"
      (submitted)="onSubmit()"
      (cancelled)="onCancel()"
    ></rk-footer-actions>
  </div>
}
